/**
 * Product-card quick add drawer.
 *
 * The drawer reuses the product page's variant controls, but keeps the
 * shopper in the collection/search page. It deliberately does not open
 * Dawn's cart notification or cart drawer after a successful add.
 */
(function () {
  if (customElements.get('sawaaro-quick-add-modal')) return;

  function readJson(element) {
    try {
      return element ? JSON.parse(element.textContent) : [];
    } catch (error) {
      return [];
    }
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
  }

  function namespaceIds(root, prefix) {
    var ids = {};
    root.querySelectorAll('[id]').forEach(function (element) {
      var original = element.id;
      var replacement = prefix + '-' + original;
      ids[original] = replacement;
      element.id = replacement;
    });

    root.querySelectorAll('[for]').forEach(function (element) {
      if (ids[element.htmlFor]) element.htmlFor = ids[element.htmlFor];
    });
  }

  function selectedColor(info) {
    var fieldsets = Array.prototype.slice.call(info.querySelectorAll('fieldset'));
    var colourFieldset = fieldsets.find(function (fieldset) {
      var label = fieldset.querySelector('[data-option-name]');
      return label && /colou?r/i.test(label.getAttribute('data-option-name'));
    });
    var selected = colourFieldset && colourFieldset.querySelector('input[type="radio"]:checked');
    return selected ? selected.value : '';
  }

  function colorOptionIndex(info) {
    var fieldsets = Array.prototype.slice.call(info.querySelectorAll('fieldset'));
    return fieldsets.findIndex(function (fieldset) {
      var label = fieldset.querySelector('[data-option-name]');
      return label && /colou?r/i.test(label.getAttribute('data-option-name'));
    });
  }

  function mediaForColor(media, variantMedia, colour, colourIndex) {
    if (!media.length || !colour) return media;

    var colourVariants = variantMedia.filter(function (variant) {
      return colourIndex >= 0 && variant.options && variant.options[colourIndex] === colour;
    });
    var variantIds = colourVariants.map(function (variant) {
      return String(variant.id);
    });
    var featuredIds = colourVariants
      .map(function (variant) {
        return variant.featured_media_id;
      })
      .filter(Boolean)
      .map(String);

    // Shopify's image-to-variant assignment is the strongest grouping signal.
    var assignedImages = media.filter(function (item) {
      return (item.variant_ids || []).some(function (id) {
        return variantIds.indexOf(String(id)) !== -1;
      });
    });
    if (assignedImages.length) return assignedImages;

    var featuredImages = media.filter(function (item) {
      return featuredIds.indexOf(String(item.id)) !== -1;
    });
    if (featuredImages.length) return featuredImages;

    // For images not explicitly assigned in Shopify, image alt text can
    // still group a colour gallery (for example: "Rose detail front").
    var colourKey = colour.trim().toLowerCase();
    var altMatches = media.filter(function (item) {
      return (item.alt || '').toLowerCase().indexOf(colourKey) !== -1;
    });
    return altMatches.length ? altMatches : media;
  }

  function updateCartCount(itemCount) {
    document.querySelectorAll('.sw-cart-btn').forEach(function (link) {
      link.setAttribute('aria-label', itemCount ? 'Cart, ' + itemCount + ' items' : 'Cart');
      var badge = link.querySelector('[data-sw-cart-count]');
      if (!itemCount) {
        if (badge) badge.remove();
        return;
      }
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'sw-cart-badge';
        badge.setAttribute('data-sw-cart-count', '');
        link.appendChild(badge);
      }
      badge.textContent = itemCount;
    });

    var cartIcon = document.querySelector('#cart-icon-bubble');
    if (!cartIcon) return;

    var bubble = cartIcon.querySelector('.cart-count-bubble');
    if (!itemCount) {
      if (bubble) bubble.remove();
      return;
    }

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      cartIcon.appendChild(bubble);
    }
    bubble.innerHTML =
      (itemCount < 100 ? '<span aria-hidden="true">' + itemCount + '</span>' : '') +
      '<span class="visually-hidden">Cart has ' + itemCount + ' items</span>';
  }

  function refreshCartCount() {
    return fetch(window.routes.cart_url + '.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to refresh cart count');
        return response.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count || 0);
        return cart;
      });
  }

  class SawaaroQuickAddDrawer extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.sawaaro-quick-add-drawer__content');
      this.panel = this.querySelector('.sawaaro-quick-add-drawer__panel');
      this.opener = null;
      this.gallery = null;
      this.handleKeydown = this.handleKeydown.bind(this);
    }

    connectedCallback() {
      var self = this;
      this.querySelectorAll('[data-sawaaro-drawer-close]').forEach(function (button) {
        button.addEventListener('click', function () {
          self.hide();
        });
      });
    }

    show(opener) {
      var productUrl = opener && opener.getAttribute('data-product-url');
      if (!productUrl || !this.content) return;

      this.opener = opener;
      // Move drawer to body so it sits above all page sections
if (this.parentElement !== document.body) {
  document.body.appendChild(this);
}
      this.setAttribute('open', '');
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('sawaaro-quick-add-open');
      document.body.style.overflow = '';
      document.addEventListener('keydown', this.handleKeydown);
      this.panel.focus();
      this.content.innerHTML = '<div class="sawaaro-quick-add__loading">Loading product options…</div>';

      var sectionUrl = new URL(productUrl, window.location.origin);
      sectionUrl.searchParams.set('section_id', 'main-product-sawaaro');

      var self = this;
      fetch(sectionUrl.toString())
        .then(function (response) {
          if (!response.ok) throw new Error('Product section could not be loaded');
          return response.text();
        })
        .then(function (html) {
          if (!self.hasAttribute('open')) return;

          var doc = new DOMParser().parseFromString(html, 'text/html');
          var info = doc.querySelector('.sawaaro-pdp .info');
          var variants = readJson(doc.getElementById('SawaaroVariantsJSON'));
          var media = readJson(doc.getElementById('SawaaroMediaJSON'));
          var variantMedia = readJson(doc.getElementById('SawaaroVariantMediaJSON'));

          if (!info || !variants.length) throw new Error('Product options are unavailable');
          self.render(info, variants, media, variantMedia);
        })
        .catch(function () {
          if (!self.hasAttribute('open')) return;
          self.content.innerHTML =
            '<div class="sawaaro-quick-add__error">Sorry, this product could not be loaded. Please try again.</div>';
        });
    }

    hide() {
      if (!this.hasAttribute('open')) return;
      this.removeAttribute('open');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('sawaaro-quick-add-open');
      document.removeEventListener('keydown', this.handleKeydown);
      if (this.content) this.content.innerHTML = '';
      this.gallery = null;
      if (this.opener) this.opener.focus();
      this.opener = null;
    }

    handleKeydown(event) {
      if (event.key === 'Escape') this.hide();
    }

    render(info, variants, media, variantMedia) {
      var self = this;
      var copy = info.cloneNode(true);
      namespaceIds(copy, 'quick-add-' + Date.now());
      this.content.innerHTML = '';

      if (media.length) {
        this.gallery = this.createGallery();
        this.content.appendChild(this.gallery.element);
      }
      this.content.appendChild(copy);

      copy.addEventListener('sawaaro:variant-change', function (event) {
        self.updateGallery(mediaForColor(media, variantMedia, selectedColor(copy), colorOptionIndex(copy)), event.detail.variant);
      });

      if (window.SawaaroVariantSelect) window.SawaaroVariantSelect(copy, variants);
      this.updateGallery(mediaForColor(media, variantMedia, selectedColor(copy), colorOptionIndex(copy)));
      this.attachQuantityControls(copy);
      this.attachSubmitHandler(copy.querySelector('form'));
    }

    createGallery() {
      var element = document.createElement('section');
      element.className = 'sawaaro-quick-add-gallery';
      element.innerHTML =
        '<div class="sawaaro-quick-add-gallery__main"><img alt="" loading="eager"></div>' +
        '<div class="sawaaro-quick-add-gallery__thumbs" aria-label="Product images"></div>';
      return {
        element: element,
        main: element.querySelector('img'),
        thumbs: element.querySelector('.sawaaro-quick-add-gallery__thumbs'),
      };
    }

    updateGallery(media) {
      if (!this.gallery || !media || !media.length) return;
      var gallery = this.gallery;
      gallery.thumbs.innerHTML = '';
      gallery.main.src = media[0].src;
      gallery.main.alt = media[0].alt || '';

      media.forEach(function (item, index) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'sawaaro-quick-add-gallery__thumb' + (index === 0 ? ' is-active' : '');
        button.setAttribute('aria-label', 'View image ' + (index + 1));
        button.innerHTML = '<img src="' + escapeHtml(item.thumb || item.src) + '" alt="">';
        button.addEventListener('click', function () {
          gallery.main.src = item.src;
          gallery.main.alt = item.alt || '';
          gallery.thumbs.querySelectorAll('button').forEach(function (thumb) {
            thumb.classList.remove('is-active');
          });
          button.classList.add('is-active');
        });
        gallery.thumbs.appendChild(button);
      });
    }

    attachQuantityControls(root) {
      var input = root.querySelector('.qty-val');
      var minus = root.querySelector('.qty-minus');
      var plus = root.querySelector('.qty-plus');
      if (!input || !minus || !plus) return;

      minus.addEventListener('click', function () {
        input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
      });
      plus.addEventListener('click', function () {
        input.value = parseInt(input.value || '1', 10) + 1;
      });
    }

    attachSubmitHandler(form) {
      if (!form) return;
      var self = this;
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var submitButton = form.querySelector('.add-to-bag');
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = 'Adding…';
        }

        var existingError = self.content.querySelector('.sawaaro-quick-add__error');
        if (existingError) existingError.remove();

        fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            if (data.status) throw new Error(data.description || data.message || 'Could not add this item to the cart.');
            return refreshCartCount();
          })
          .then(function () {
            self.hide();
          })
          .catch(function (error) {
            self.content.insertAdjacentHTML(
              'afterbegin',
              '<div class="sawaaro-quick-add__error">' + escapeHtml(error.message || 'Something went wrong. Please try again.') + '</div>'
            );
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.textContent = 'Add to Bag';
            }
          });
      });
    }
  }

  customElements.define('sawaaro-quick-add-modal', SawaaroQuickAddDrawer);
})();
